export default __webpack_public_path__ + "static/media/home.c8e5effa.pdf";